/* eslint-disable jsx-a11y/label-has-for */
import React from "react";
import ReactInputMask from "react-input-mask";

function StepThreeEmplHistBreak({ state, onBlur, onKeyDown, handleChange, handleCurrentlyOnbreak }) {
  return (
    <>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-9">
          <span id="emp_hist_break_text">
            Please select from the following to explain
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div
          className="col-md-12 custom-control custom-radio"
          style={{ marginLeft: "15px" }}
        >
          <input
            type="radio"
            id="fulltime_student"
            name="employmentbreak"
            className="custom-control-input"
            checked={state.fulltime_student === "Y"}
            value="Y"
            onChange={handleChange}
          />
          <label
            id="emp_hist_fulltime_student_label"
            htmlFor="fulltime_student"
            className="custom-control-label"
          >
            <strong>Full Time Student</strong>
          </label>
        </div>
      </div>
      <div className="row">
        <div
          className="col-md-12 custom-control custom-radio"
          style={{ marginLeft: "15px" }}
        >
          <input
            type="radio"
            id="homemaker"
            name="employmentbreak"
            className="custom-control-input"
            checked={state.homemaker === "Y"}
            value="Y"
            onChange={handleChange}
          />
          <label
            id="emp_hist_homemaker_label"
            htmlFor="homemaker"
            className="custom-control-label"
          >
            <strong>Homemaker</strong>
          </label>
        </div>
      </div>
      <div className="row">
        <div
          className="col-md-12 custom-control custom-radio"
          style={{ marginLeft: "15px" }}
        >
          <input
            type="radio"
            id="unemployment"
            name="employmentbreak"
            className="custom-control-input"
            checked={state.unemployment === "Y"}
            value="Y"
            onChange={handleChange}
          />
          <label
            id="emp_hist_unemployment_label"
            htmlFor="unemployment"
            className="custom-control-label"
          >
            <strong>Unemployment</strong>
          </label>
        </div>
      </div>
      <div className="row">
        <div
          className="col-md-12 custom-control custom-radio"
          style={{ marginLeft: "15px" }}
        >
          <input
            type="radio"
            id="military"
            name="employmentbreak"
            className="custom-control-input"
            checked={state.military === "Y"}
            value="Y"
            onChange={handleChange}
          />
          <label
            id="emp_hist_military_label"
            htmlFor="military"
            className="custom-control-label"
          >
            <strong>Military Service</strong>
          </label>
        </div>
      </div>
      <div className="row">
        <div
          className="col-md-12 custom-control custom-radio"
          style={{ marginLeft: "15px" }}
        >
          <input
            type="radio"
            id="travel"
            name="employmentbreak"
            className="custom-control-input"
            checked={state.travel === "Y"}
            value="Y"
            onChange={handleChange}
          />
          <label
            id="emp_hist_travel_label"
            htmlFor="travel"
            className="custom-control-label"
          >
            <strong>Extended Travel</strong>
          </label>
        </div>
      </div>
      <div className="row">
        <div
          className="col-md-12 custom-control custom-radio"
          style={{ marginLeft: "15px" }}
        >
          <input
            type="radio"
            id="other"
            name="employmentbreak"
            className="custom-control-input"
            checked={state.other === "Y"}
            value="Y"
            onChange={handleChange}
          />
          <label
            id="emp_hist_other_label"
            htmlFor="other"
            className="custom-control-label"
          >
            <strong>Other</strong>
          </label>
        </div>
      </div>
      {state.show_other_panel && (
        <>
          <label htmlFor="other_text" id="emp_hist_other_text_label">
            <strong>Please provide an explanation*</strong>
          </label>
          <div>
            {" "}
            <textarea
              rows="3"
              id="other_text"
              className={
                state.other_text_error
                  ? "form-control is-invalid"
                  : "form-control"
              }
              maxLength={100}
              autoComplete="new-password"
              value={state.other_text}
              onBlur={onBlur}
              onChange={handleChange}
              onKeyDown={onKeyDown}
            ></textarea>
          </div>
          {state.other_text_error && (
            <div id="other_text_error" className="invalid-feedback show">
              Please enter an explanation
            </div>
          )}
        </>
      )}

      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-7">
          <span id="emp_hist_currently_onbreak_label">
            I am currently on this Employment Break
            <strong>*</strong>
          </span>
        </div>
        <div className="col-md-2 custom-control custom-radio">
          <input
            type="radio"
            id="currently_onbreak_yes"
            name="currently_onbreak"
            className="custom-control-input"
            checked={state.currently_onbreak === "Y"}
            value="Y"
            onChange={handleCurrentlyOnbreak}
          />
          <label
            htmlFor="currently_onbreak_yes"
            className="custom-control-label"
            id="label_currently_onbreak_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="currently_onbreak_no"
            name="currently_onbreak"
            className="custom-control-input"
            checked={state.currently_onbreak === "N"}
            value="N"
            onChange={handleCurrentlyOnbreak}
          />
          <label
            htmlFor="currently_onbreak_no"
            className="custom-control-label"
            id="label_currently_onbreak_no"
          >
            No
          </label>
        </div>
      </div>
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-6">
          <label
            htmlFor="break_start_date"
            id="emp_hist_break_start_date_label"
          >
            <strong>Start Date*</strong>
          </label>
          <ReactInputMask
            id="break_start_date"
            mask="99/99/9999"
            maskChar="_"
            className={
              state?.break_start_date_error
                ? "form-control is-invalid"
                : "form-control"
            }
            placeholder="MM/DD/YYYY"
            autoComplete="off"
            value={state.break_start_date}
            onBlur={onBlur}
            onChange={handleChange}
            onKeyDown={onKeyDown}
          />
          {state?.break_start_date_error && (
            <div id="break_start_date_error" className="invalid-feedback show">
              {state?.break_start_date_error_text}
            </div>
          )}
        </div>
        <div className="col-md-6">
          <label htmlFor="break_end_date" id="emp_hist_break_end_date_label">
            <strong>End Date*</strong>
          </label>
          <ReactInputMask
            id="break_end_date"
            mask="99/99/9999"
            maskChar="_"
            className={
              state?.break_end_date_error
                ? "form-control is-invalid"
                : "form-control"
            }
            placeholder="MM/DD/YYYY"
            autoComplete="off"
            value={state.break_end_date}
            onBlur={onBlur}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            disabled={state.break_end_date_disabled}
          />
          {state?.break_end_date_error && (
            <div id="break_end_date_error" className="invalid-feedback show">
              {state?.break_end_date_error_text}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default StepThreeEmplHistBreak;
